<script>
export default {
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    items: [
      {
        value: 'preview',
        label: 'Описание',
      },
      {
        value: 'program',
        label: 'Программа тура',
      },
      {
        value: 'condition',
        label: 'Условия',
      },
      {
        value: 'cancellation',
        label: 'Аннуляция',
      },
      {
        value: 'mark',
        label: 'Метки тура',
      },
    ],
    value: 'preview',
  }),
};
</script>
<template>
  <Card full>
    <CardTabs
      :items="items"
      v-model="value"
    />
    <CardBody
      v-if="value === 'preview'"
      class="min-height1"
    >
      <FItem
        :module="module.min"
      />
      <FItem
        :module="module.preview"
      />
      <FItem
        :module="module.gallery"
      />
    </CardBody>
    <CardBody
      v-if="value === 'program'"
      class="min-height"
      full
    >
      <FItem
        key="program"
        :module="module.program"
        style="padding: 0;"
      />
    </CardBody>
    <CardBody
      v-if="value === 'condition'"
      class="min-height"
      full
    >
      <FItem
        :module="module.condition"
        key="condition"
        style="padding: 0;"
      />
    </CardBody>
    <CardBody
      v-if="value === 'cancellation'"
      class="min-height"
      full
    >
      <FItem
        :module="module.cancellation"
        key="cancellation"
        style="padding: 0;"
      />
    </CardBody>
    <CardBody
      v-if="value === 'mark'"
      class="min-height"
      full
    >
      <FItem
        :module="module.mark"
        key="mark"
        style="padding: 0;"
      />
    </CardBody>
  </Card>
</template>
<style lang="scss" scoped>
  .min-height {
    min-height: 477px;
  }
  .min-height1 {
    min-height: 429px;
  }
</style>
